import script from "./AddPropertyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AddPropertyPage.vue?vue&type=script&setup=true&lang=js"

import "./AddPropertyPage.vue?vue&type=style&index=0&id=40f4415e&scoped=true&lang=css"
import "./AddPropertyPage.vue?vue&type=style&index=1&id=40f4415e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40f4415e"]])

export default __exports__